<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :allowFields="$lang.searchTemplateFields"
      :title="$lang.searchTemplate"
      :remove_item="remove_item"
      config="template"
      :toggleable="true"
      :allowRemove="true"
      add-modal-size="lg"
      remove-modal-size="xl"
      :isLoading="isLoading"
      ref="template_search"
      :dynamicButtons="buttons"
      @getPermisson="updatePermissions"
    >
      <template slot="addModal" slot-scope="search">
        <AddTemplate
          isModal
          @close="search.close"
          @getData="getData"
          :permissions="permissions"
        />
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddTemplate from "./addTemplate";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    Search,
    AddTemplate,
  },
  data() {
    return {
      isLoading: false,
      permissions: [],
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "4",
          name: "clone",
          click: this.cloneTemplate,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "template"]);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    async remove_item(item) {
      const id = pathOr(null, ["id"], item);
      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "template_id"], [id]);
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async cloneTemplate(item) {
      const id = pathOr(null, ["id"], item);
      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "template_duplicate"], [id]);
        const response = await this.$httpService.post(url);
        this.$notify.success(response.data.message);
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    getData() {
      this.$refs.template_search.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = permissions;
    },
  },
};
</script>
